import { BaseService } from './BaseService';

export class LegalDocumentService extends BaseService {
    async getDocuments(type) {
        const query = type ? `?type=${encodeURIComponent(type)}` : '';
        return this.get(`/legal-documents${query}`, true);
    }

    async createDraft(type, content) {
        return this.post('/legal-documents', { type, content }, true);
    }

    async publish(id) {
        return this.patch(`/legal-documents/${id}/publish`, {}, true);
    }

    async deleteDraft(id) {
        return this.delete(`/legal-documents/${id}`, true);
    }

    async getNotifyPreview(id) {
        return this.get(`/legal-documents/${id}/notify-preview`, true);
    }

    async notify(id) {
        return this.post(`/legal-documents/${id}/notify`, {}, true);
    }
}
